import AvatarMask from '@henwend/modules/christmas/avatar_mask';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { implog } from '@/api/implog';
import { ACCESS_TOKEN_KEY, ACCESS_USERID_KEY } from '@/constant/config';
import useAvatar, { useAvatarV2 } from '@/hooks/useAvatar';
import useParam from '@/hooks/useParam';
import Coin from '@/modules/coin/v3';
import Notlogin from '@/pages/game/components/notlogin';
import globalStore from '@/stores/store';
import Storage from '@/utils/Storage';
import { isUserQuit } from '@/utils/utils';

import styles from './styles.module.less';

const Avatar: FC = () => {
  const { type } = useParam<{ type?: number }>();
  const isGameing = !!(type && +type === 1);
  const navigate = useNavigate();
  const { viplevel } = globalStore.initialState;
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  // const avatar = useAvatar(userid);
  const { url: avatar } = useAvatarV2(globalStore.userInfo?.face_512 || userid);
  const token = Storage.getAccess(ACCESS_TOKEN_KEY);
  if (!token && isUserQuit()) {
    console.log('token is null, redirect to login');
    return <Notlogin />;
  }
  const vipUrl = `${window.imgPrefix}/img/vip-level/vip_icon${`${viplevel}`.padStart(2, '0')}.webp`;

  return (
    <div className={styles.box}>
      <Coin />
      <div
        className={styles.avatarbox}
        onClick={() => {
          if (isGameing) return;
          navigate('/my');
          implog('menu_user_icon_click');
        }}
      >
        <div className={styles.avatar} style={{ backgroundImage: `url(${avatar})` }} />
        <AvatarMask />
        <div className={styles.vipbox}>
          <div className={styles.vip} style={{ backgroundImage: `url(${vipUrl})` }}></div>
          {/* <span>{viplevel}</span> */}
        </div>
      </div>
    </div>
  );
};

const AvatarCom = observer(Avatar);
AvatarCom.displayName = 'Avatar';

export default AvatarCom;
